import {
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  TextField,
  Container,
  Autocomplete,
  Typography,
  Snackbar,
  Alert,
  AlertTitle,
  FormGroup,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";
import CircularProgress from '@mui/material/CircularProgress';
import QueueSelector from "./QueueSelector";
import {
  createSCRule,
  getAirlineDetails,
  getQCACustomer,
  getCustomerByID,
  getSCRuleByID,
  updateSCRule,
  getQueueListByPCC, // <-- expected redux action
} from "../redux/actions/AdminAction";
import { useNavigate, useParams } from "react-router-dom";
import { GET_SC_RULE_RESET } from "../Constants/Constants";
import { TimePicker } from "@mui/x-date-pickers";
import { parse, format, isValid } from "date-fns";

export default function ScheduleChangeRule() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  // basic states
  const [rule_name, setRule_name] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [isUpdateForm, setIsUpdateForm] = useState(false);
  const [customerId, setCustomerId] = useState();
  const [PCCs, setPCCs] = useState([]); // stored selected PCCs
  const [availablePCCs, setAvailablePCCs] = useState([]); // from customerById
  const [availableQueue, setAvailableQueue] = useState([]); // ✅ make it an array


  const [isActive, setIsActive] = useState(false);
  const [selectAllAirlines, setSelectAllAirlines] = useState(true);
  const [airline_code, setAirline_code] = useState([]);
  const [selectSendEmailForAllPax, setSelectSendEmailForAllPax] = useState(true);

  const [run_time, setRun_time] = useState("");
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // dialogs
  const [confirmSaveOpen, setConfirmSaveOpen] = useState(false);
  const [confirmRemovePCCOpen, setConfirmRemovePCCOpen] = useState(false);
  const [pccToRemove, setPccToRemove] = useState(null);
  // redux selectors
  const HXCancellationGetAirlineDetails = useSelector(
    (state) => state.HXCancellationGetAirlineDetails
  );
  const { airlineInfo } = HXCancellationGetAirlineDetails;

  const GetSCRuleByID = useSelector((state) => state.GetSCRuleByID);
  const { ruleInfo } = GetSCRuleByID || {};

  const GetCustomers = useSelector((state) => state.GetCustomers);
  const { customersInfo } = GetCustomers || {};

  const GetCustomerByID = useSelector((state) => state.GetCustomerByID);
  const { customerById } = GetCustomerByID || {};

  // const GetQueueListByPCC = useSelector((state) => state.GetQueueListByPCC);
  // const queueData = GetQueueListByPCC.getQueueListByPCC || null;
  const GetQueueListByPCC = useSelector((state) => state.GetQueueListByPCC);
  const queueData = GetQueueListByPCC?.getQueueListByPCC || null;
  const isLoadingQueue = GetQueueListByPCC?.loading || false;

  const ScheudleChangeCreateSCRule = useSelector(
    (state) => state.ScheudleChangeCreateSCRule
  );
  const { scRuleInfo, error } = ScheudleChangeCreateSCRule || {};

  const UpdateSCRule = useSelector((state) => state.UpdateSCRule);
  const { success, message, updateerror } = UpdateSCRule || {};

  const token = JSON.parse(localStorage.getItem("userInfo"));

  useEffect(() => {
    dispatch({ type: GET_SC_RULE_RESET });
  }, [dispatch]);

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      setSelectAllAirlines(true);
    }
  }, [dispatch, navigate, token]);

  // when branch is edit (id !== 'new'), fetch existing rule
  useEffect(() => {
    setSelectAllAirlines(true);
    if (id === "new") {
      // reset
      setRule_name("");
      setIsActive(false);
      setPCCs([]);
      setAirline_code([]);
      setSelectAllAirlines(true);
      setSelectSendEmailForAllPax(true);
      setRun_time("");
      setCustomerId();
      setIsUpdateForm(false);
      dispatch(getAirlineDetails());
      dispatch(getQCACustomer());
      dispatch({ type: GET_SC_RULE_RESET });
    } else {
      dispatch(getSCRuleByID(id));
      dispatch(getAirlineDetails());
    }
  }, [id, dispatch]);

  // populate form when ruleInfo loads (for update)
  useEffect(() => {
    if (ruleInfo && Object.keys(ruleInfo).length > 0) {
      setRule_name(ruleInfo.rule_name || "");
      setIsActive(Boolean(ruleInfo.active));
      setPccList(
        ruleInfo.pccList && Array.isArray(ruleInfo.pccList)
          ? ruleInfo.pccList
          : []
      );
      setAirline_code(
        ruleInfo.airlines
          ? ruleInfo.airlines.trim().split(",").map((a) => a.trim()).filter(Boolean)
          : []
      );
      setSelectAllAirlines(!(ruleInfo.airlines && ruleInfo.airlines.trim()));
      setSelectSendEmailForAllPax(Boolean(ruleInfo.is_email_for_all_pax_enabled));

      setRun_time(ruleInfo.run_time?.trim() || "");
      setCustomerId(ruleInfo.customer_id);
      setIsUpdateForm(true);
    }
  }, [ruleInfo]);

  // when customerById changes, pick available PCCs
  useEffect(() => {
    if (customerById && customerById.pccs) {
      // assume pccs come as space-separated string
      const pccArray = customerById.pccs.split(" ").map((s) => s.trim()).filter(Boolean);
      setAvailablePCCs(pccArray);
      // if no PCCs set in form and customer has default pccs, populate
     
    }
  }, [customerById]);

  useEffect(() => {
    if (
      queueData?.status === "success" &&
      Array.isArray(queueData.qca_list?.queues_list)
    ) {
      const pcc = queueData.qca_list.pcc;

      // Extract queue names (["Q22", "Q95", ...])
      const formattedQueues = queueData.qca_list.queues_list.map(([name]) => name);

      setAvailableQueue((prev) => {
        // Check if PCC already exists
        const existingIndex = prev.findIndex((item) => item.pcc === pcc);

        if (existingIndex !== -1) {
          // ✅ Update existing PCC queues
          const updated = [...prev];
          updated[existingIndex] = { pcc, queues: formattedQueues };
          return updated;
        }

        // ✅ Add new PCC queues
        return [...prev, { pcc, queues: formattedQueues }];
      });

      console.log("✅ Available queues updated for", pcc, ":", formattedQueues);
    }
  }, [queueData]);


  const [pccList, setPccList] = useState([]);

  const handleAddPCC = (event, newPcc) => {
    if (!newPcc) return;

    // Avoid duplicates
    setPccList((prev) =>
      prev.find((p) => p.pcc === newPcc)
        ? prev
        : [...prev, { pcc: newPcc, queues: [] }]
    );
    const pcc = newPcc.trim();
    if (!PCCs.includes(pcc)) {
      setPCCs((prev) => [...prev, pcc]);
    }
    dispatch(getQueueListByPCC(newPcc));
  };

  // snack close
  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackOpen(false);
    setErrorAlert(false);
  };


  // remove PCC with confirmation
  // 🔸 Step 1: Ask confirmation before removal
  const confirmRemovePCC = (pccValue) => {
    setPccToRemove(pccValue);
    setConfirmRemovePCCOpen(true);
  };

  // 🔸 Step 2: Remove PCC after confirmation
  const handleConfirmRemovePCC = () => {
    if (pccToRemove) {
      setPccList((prev) => prev.filter((p) => p.pcc !== pccToRemove));
    }
    setPccToRemove(null);
    setConfirmRemovePCCOpen(false);
  };


  const handleIsActive = (event) => {
    setIsActive(event.target.checked);
  };

  const handleSelectAllAirlines = (event) => {
    setSelectAllAirlines(event.target.checked);
    setAirline_code([]);
  };

  const handleSelectSendEmailForAllPax = (event) => {
    const value = event.target.value === "true";
    setSelectSendEmailForAllPax(value);
  };


  const handleRunTime = (newValue) => {
    if (newValue && isValid(newValue)) {
      const selectedTime = format(newValue, "HHmm");
      setRun_time((prevRunTime) =>
        !prevRunTime ? selectedTime : prevRunTime.includes(selectedTime) ? prevRunTime : `${prevRunTime} ${selectedTime}`
      );
    }
  };

  const getPccError = () => {
    for (const pcc of pccList) {
      for (const q of pcc.queues) {

        // REQUIRED field checks
        if (!q.queue || q.queue.trim() === "") {
          return `Please select Queue number for PCC ${pcc.pcc}.`;
        }
        if (!q.email || q.email.trim() === "") {
          return `Default Email is required for queue ${q.queue}.`;
        }
        // VALIDATION error checks
        if (q.errors && Object.keys(q.errors).length > 0) {
          return Object.values(q.errors)[0];
        }
      }
    }

    return null; // no errors
  };

  const validateForm = () => {
    if (!rule_name) {
      return "Rule name is required.";
    }

    if (pccList.length === 0) {
      return "Please add at least one PCC.";
    }

    if (!selectAllAirlines && airline_code.length === 0) {
      return "Please select an airline or choose 'Select All'.";
    }

    if (!run_time) {
      return "Run time is required.";
    }

    if (!customerId) {
      return "Customer is required.";
    }

    // PCC/Queue-level errors (email, etc.)
    const pccError = getPccError(); // from earlier
    if (pccError) {
      return pccError; // custom PCC error message
    }

    return null; // No errors!
  };

  // open confirm save dialog
  const handleOpenConfirmSave = () => {
    const validationError = validateForm();
    if (validationError) {
      setErrorMessage(validationError); // custom message
      setErrorAlert(true);
      setSnackOpen(true);
      return; // ❌ do NOT open confirm modal
    }

    setConfirmSaveOpen(true); // ✅ only open if no errors
  };


  const handleCancelConfirmSave = () => setConfirmSaveOpen(false);

  // actual submit
  const doSubmit = () => {
    // validate required fields
    if (
      rule_name &&
      pccList.length > 0 &&
      (airline_code.length > 0 || selectAllAirlines) &&
      run_time &&
      customerId
    ) {
      // build payload
      const sc_rule = {
        rule_name: rule_name?.trim(),
        active: isActive || false,
        pccList: pccList,
        airlines: airline_code?.map((airline) => airline?.trim()).join(","),
        run_time: run_time,
        customer_id: customerId,
        is_email_for_all_pax_enabled: selectSendEmailForAllPax || true,
        send_whatsapp_notification: false, // default false for now
      };

      if (id === "new") {
        dispatch(createSCRule(sc_rule));
      } else {
        dispatch(updateSCRule(id, sc_rule));
      }

      setSnackOpen(true);
      setConfirmSaveOpen(false);
      // navigate after small delay to allow Redux success messages to show
      setTimeout(() => {
        navigate("/scheduleChangeRules");
      }, 1500);
    } else {
      setSnackOpen(true);
      setErrorAlert(true);
      setConfirmSaveOpen(false);
    }
  };

  // helper: display selected PCCs buttons with remove option
  const SelectedPCCsList = () => (
    <Box sx={{ mt: 1, mb: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
      {pccList.map((pccData) => (
        <Button
          key={pccData.pcc}
          startIcon={<ClearIcon />}
          onClick={() => confirmRemovePCC(pccData.pcc)}
          size="small"
          variant="outlined"
        >
          {pccData.pcc}
        </Button>
      ))}
    </Box>
  );


  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box>
        <Box sx={{ margin: 3, fontSize: 25 }}>
          Manage Schedule Change Rules
          <Divider sx={{ marginTop: 2 }} />
        </Box>

        <Box sx={{ fontSize: 25, margin: 3 }}>
          {id === "new" ? "Add Schedule Change Rule" : "Edit Schedule Change Rule"}
        </Box>

        <Box sx={{ margin: 3 }}>
          <Grid container spacing={2}>
            {isUpdateForm ? (
              <Grid item xs={12} md={6}>
                <FormLabel>Agency Name</FormLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={rule_name}
                  disabled
                />
              </Grid>
            ) : (
              <Grid item xs={12} md={6}>
                <FormLabel>Agency Name</FormLabel>
                  <Autocomplete
                fullWidth
                disabled={isUpdateForm}        // 🔒 disable the dropdown
                disableClearable={isUpdateForm} // optional: prevent clearing
                options={(customersInfo && Object.values(customersInfo)) || []}
                onChange={(e, newValue) => {
                  if (isUpdateForm) return; // 🔒 block updates when read-only

                  if (newValue) {
                    setRule_name(newValue.customer_name);
                    setCustomerId(newValue.customer_id);
                    setPccList([]);
                    dispatch(getCustomerByID(newValue.customer_id));
                  } else {
                    setRule_name("");
                    setCustomerId();
                  }
                }}
                getOptionLabel={(option) => option?.customer_name?.trim() || ""}
                value={
                  (customersInfo &&
                    customersInfo.find(
                      (customer) => customer?.customer_name?.trim() === rule_name?.trim()
                    )) ||
                  null
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      readOnly: isUpdateForm,     // 🔒 prevent typing
                    }}
                  />
                )}
              />
              </Grid>
            )}


            <Grid item xs={12} md={6}>
              Active?
              <Checkbox checked={isActive} onChange={handleIsActive} />
            </Grid>

            <Grid item xs={12} md={12}>
              <FormLabel sx={{ color: "black !important" }}>
                Send email notification :
              </FormLabel>
              <RadioGroup
                sx={{ marginLeft: 2 }}
                value={selectSendEmailForAllPax}
                onChange={handleSelectSendEmailForAllPax}
              >
                <FormControlLabel value={true} control={<Radio />} label="One email for all passengers in PNR" />
                <FormControlLabel value={false} control={<Radio />} label="Send email per passenger" />
              </RadioGroup>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormLabel>Select PCC</FormLabel>
              <Autocomplete
                fullWidth
                options={availablePCCs || []}
                value={null}
                onChange={handleAddPCC}
                loading={isLoadingQueue}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Queue"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {isLoadingQueue && <CircularProgress color="inherit" size={20} />}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />


              <FormLabel sx={{ mt: 2 }}>Selected PCCs</FormLabel>
              {pccList.length > 0 && (
                <SelectedPCCsList pccList={pccList} />)}
            </Grid>
            {pccList.length > 0 && (
              <Grid item xs={12} md={12}>
                <QueueSelector
                  availableQueue={availableQueue}
                  pccList={pccList}
                  setPccList={setPccList}
                />
              </Grid>
            )}
            {/* Airlines */}
            <Grid item xs={12} md={12}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <FormLabel>Airlines</FormLabel>
                <FormLabel>
                  Select all Airlines
                  <Checkbox checked={selectAllAirlines} onChange={handleSelectAllAirlines} />
                </FormLabel>
              </Box>

              <Autocomplete
                disabled={selectAllAirlines}
                multiple
                fullWidth
                options={airlineInfo || []}
                getOptionLabel={(option) => `${option.airline_code} - ${option.airline_name}` || ""}
                value={
                  airline_code
                    .map(
                      (code) =>
                        airlineInfo?.find((airline) => airline.airline_code === code) || null
                    )
                    .filter(Boolean)
                }
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option.airline_code.toLowerCase().includes(inputValue.toLowerCase()) ||
                    option.airline_name.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                onChange={(e, newVal) => {
                  // keep airline_code state as array of codes
                  const codes = newVal.map((a) => a.airline_code);
                  setAirline_code(codes);
                }}
                renderInput={(params) => <TextField {...params} variant="outlined" />}
              />
              {/* display currently selected airline buttons */}
              <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
                {airline_code.map((code, idx) => {
                  const airline = airlineInfo?.find((a) => a.airline_code === code);
                  return (
                    <Button
                      key={idx}
                      size="small"
                      variant="outlined"
                      startIcon={<ClearIcon />}
                      onClick={() => setAirline_code((prev) => prev.filter((c) => c !== code))}
                    >
                      {airline ? `${airline.airline_name} (${code})` : code}
                    </Button>
                  );
                })}
              </Box>
            </Grid>
            {/* Run time */}
            <Grid item xs={12} md={6}>
              <FormLabel>Run at timings (between 0000 to 2359 UTC Time)</FormLabel>
              <TimePicker
                minutesStep={60}
                ampm={false}
                mask="__:__"
                value={run_time ? parse(run_time.split(" ")[0], "HHmm", new Date()) : null}
                onAccept={handleRunTime}
                renderInput={(params) => <TextField {...params} variant="outlined" />}
              />
              {/* show selected run times as buttons */}
              {run_time && (
                <Box sx={{ mt: 2 }}>
                  {run_time.split(" ").map((time, idx) => (
                    <Button
                      key={idx}
                      startIcon={<ClearIcon />}
                      onClick={() => {
                        const arr = run_time.split(" ");
                        arr.splice(idx, 1);
                        setRun_time(arr.join(" "));
                      }}
                      sx={{ mr: 1, mb: 1 }}
                      size="small"
                    >
                      {time}
                    </Button>
                  ))}
                </Box>
              )}
            </Grid>

            <Grid item xs={12}>
              <Button onClick={handleOpenConfirmSave} variant="contained" sx={{ backgroundColor: "#282828" }}>
                Save
              </Button>
            </Grid>
          </Grid>

          {/* Snackbars for create/update/errors */}
          {scRuleInfo && (
            <Snackbar open={snackOpen} autoHideDuration={5000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
              <Alert onClose={handleSnackClose} severity="success">
                <AlertTitle>Success</AlertTitle>
                {scRuleInfo}
              </Alert>
            </Snackbar>
          )}

          {error && (
            <Snackbar open={snackOpen} autoHideDuration={5000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
              <Alert onClose={handleSnackClose} severity="error">
                <AlertTitle>Error</AlertTitle>
                {error}
              </Alert>
            </Snackbar>
          )}

          {success && message && (
            <Snackbar open={snackOpen} autoHideDuration={5000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
              <Alert onClose={handleSnackClose} severity="success">
                <AlertTitle>Success</AlertTitle>
                {message}
              </Alert>
            </Snackbar>
          )}

          {updateerror && (
            <Snackbar open={snackOpen} autoHideDuration={5000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
              <Alert onClose={handleSnackClose} severity="error">
                <AlertTitle>Error</AlertTitle>
                {updateerror}
              </Alert>
            </Snackbar>
          )}

          {errorAlert && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert onClose={handleSnackClose} severity="error">
                <AlertTitle>Error</AlertTitle>
                {errorMessage || "Please enter all the required fields."}
              </Alert>
            </Snackbar>
          )}

        </Box>
      </Box>

      {/* Confirm Save Dialog */}
      <Dialog open={confirmSaveOpen} onClose={handleCancelConfirmSave}>
        <DialogTitle>Confirm Save</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to {id === "new" ? "create" : "update"} this schedule change rule?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelConfirmSave}>Cancel</Button>
          <Button onClick={doSubmit} variant="contained">Yes, Save</Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Remove PCC Dialog */}
      <Dialog
        open={confirmRemovePCCOpen}
        onClose={() => setConfirmRemovePCCOpen(false)}
      >
        <DialogTitle>Remove PCC</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to remove{" "}
            <strong>{pccToRemove}</strong> from the selected list?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmRemovePCCOpen(false)}>No</Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirmRemovePCC}
          >
            Yes, Remove
          </Button>
        </DialogActions>
      </Dialog>

    </Container>
  );
}
